module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Webcam.js"));
	}, "Webcam");
}